import React, { useEffect, useState } from "react";
import withRouter from "../../components/withRouter";
import PropTypes from "prop-types";
import { useProfile } from "../../contexts/ProfileContext";
import { useSidebar } from "../../contexts/SidebarContext";

// Import Components
import LeftSidebarMenu from "./LeftSidebarMenu";
import { checkToken } from "../../helpers/api";
import { useLocation } from "react-router-dom";
import { IoIosArrowDropleftCircle, IoIosArrowDroprightCircle } from "react-icons/io";
import { fetchProfileDataThunk } from "../../redux/user/thunks";
import { IoMenuOutline } from "react-icons/io5";
import { toast } from "react-toastify";

const Index = (props) => {
    const [isPublicPage, setIsPublicPage] = useState(false);
    const location = useLocation();
    const sidebarRef = React.useRef(null);
    const { profileData } = useProfile();
    const { drawerOpen, setDrawerOpen, toggleDrawer, isExpanded, setIsExpanded } = useSidebar();

    const accessToken = localStorage.getItem("authUser");
    const token = accessToken.replace(/^"|"$/g, "");
    const wsUrl = `wss://admin.onmls.com/api/messaging/ws/user/${profileData?.id}?token=${token}`;

    useEffect(() => {
        const socket = new WebSocket(wsUrl);

        socket.onopen = () => {
            console.log("WebSocket connected");
        };
        socket.onmessage = (message) => {
            try {
                const payload = JSON.parse(message.data);
                // Only show notification for incoming messages from other users (not sent by current user)
                if (
                    payload.message &&
                    payload.type !== "typing_status" &&
                    payload.sender_id &&
                    payload.sender_id !== profileData?.id
                ) {
                    toast.success(payload.message, { toastId: "message" });
                }
            } catch (e) {
                // ignore parse errors
            }
        };
    }, [profileData?.id]);

    useEffect(() => {
        ValidateTokenFunction();
    }, []);

    const ValidateTokenFunction = async () => {
        const authUserToken = localStorage.getItem("authUser");
        const authUser = authUserToken ? authUserToken.replace(/^"|"$/g, "") : "";

        try {
            const response = await checkToken(authUser);
            if (response && response.success === false && location.pathname === "/sell") {
                setIsPublicPage(true);
            }
        } catch (error) {
            console.error("Error validating token:", error);
            setIsPublicPage(true);
        }
    };
    // Profile data will be fetched by the ProfileProvider
    return (
        <React.Fragment>
            <div className=" md:tw-flex tw-h-screen">
                {/* Left sidebar menu */}
                {!isPublicPage && (
                    <div className="">
                        {/* Hamburger button hidden on mobile - MobileHeader handles it */}
                        <button className={`hamburger-button tw-hidden ${drawerOpen ? "max-sm:tw-hidden" : ""}`} onClick={toggleDrawer}>
                            <IoMenuOutline color="#fff" size={40} />
                        </button>
                        <div
                            onClick={() => setIsExpanded(!isExpanded)}
                            className={`max-sm:tw-hidden tw-cursor-pointer tw-w-fit tw-z-[101] tw-fixed tw-top-[47%] tw-right-8 ${isExpanded ? "max-md:tw-left-[28%] tw-left-[19%] 2xl:tw-left-[14%]" : "tw-left-[5%] max-md:tw-left-[8%]"}`}
                        >
                            {isExpanded ? (
                                <IoIosArrowDropleftCircle className="tw-text-secondary hover:tw-text-secondary_hover  tw-text-3xl" />
                            ) : (
                                <IoIosArrowDroprightCircle className=" tw-text-secondary hover:tw-text-secondary_hover  tw-text-3xl" />
                            )}
                        </div>
                        <div
                            className={`sidebar-main-wrapper tw-relative tw-z-10 max-sm:tw-z-[50000] md:tw-z-10 md:tw-fixed tw-overflow-y-auto tw-overflow-x-hidden tw-scrollbar-none tw-scrollbar-corner-transparent tw-scrollbar-thumb-gray-300 tw-scrollbar-track-transparent max-sm:tw-w-0 max-sm:tw-h-0
                            ${isExpanded ? "max-md:tw-w-[30%] tw-w-[20%] 2xl:tw-w-[15%]" : "tw-w-[6%] max-md:tw-w-[10%]"}`}
                        >
                            <LeftSidebarMenu
                                isExpanded={isExpanded}
                                setDrawerOpen={setDrawerOpen}
                                setIsExpanded={setIsExpanded}
                                sidebarRef={sidebarRef}
                                drawerOpen={drawerOpen}
                            />
                        </div>
                    </div>
                )}
                {/* Render page content */}
                {props.children ? (
                    <main
                        className={`tw-absolute tw-min-h-screen md:tw-h-screen max-sm:tw-w-full tw-bg-background_color tw-right-0 tw-transition-all tw-duration-300
                        ${isPublicPage ? "tw-w-full" : isExpanded ? "tw-w-[80%] max-md:tw-w-[70%] 2xl:tw-w-[85%]" : "tw-w-[94%] max-md:tw-w-[90%]"}`}
                    >
                        {/* <RxHamburgerMenu
                            onClick={() => setIsExpanded(!isExpanded)}
                            className={` tw-text-[20px] tw-h-[55px]   tw-text-white tw-z-[999] ${isExpanded ? "tw-hidden" : "tw-absolute tw-top-0 tw-left-2 tw-z-[999]"}`}
                        /> */}
                        {props.children}
                    </main>
                ) : (
                    <>Loading....</>
                )}
            </div>
        </React.Fragment>
    );
};

Index.propTypes = {
    layoutMode: PropTypes.any,
};

export default withRouter(Index);
